import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static iosFeedbackStyles = {
    light: 0,
    medium: 1,
    heavy: 2,
    soft: 3,
    rigid: 4,
  };

  static androidFeedbackStyles = {
    light: 0,
    medium: 0,
    heavy: 0,
    soft: 0,
    rigid: 0,
  };

  static values = {
    style: String,
  };

  apply() {
    if (typeof androidApp !== "undefined") {
      androidApp.performHapticFeedback(this.androidFeedbackStyle);
    } else if (typeof webkit !== "undefined" && typeof webkit.messageHandlers !== "undefined") {
      try {
        webkit.messageHandlers.hapticFeedback.postMessage(this.iosFeedbackStyle);
      } catch (error) {
        console.error("HapticFeedbackController: ", error);
      }
    } else {
      console.log("HapticFeedbackController: webkit.messageHandlers not found");
    }
  }

  get iosFeedbackStyle() {
    if (this.hasStyleValue && this.styleValue in this.constructor.iosFeedbackStyles) {
      return this.constructor.iosFeedbackStyles[this.styleValue];
    }

    return this.constructor.iosFeedbackStyles.soft;
  }

  get androidFeedbackStyle() {
    if (this.hasStyleValue && this.styleValue in this.constructor.androidFeedbackStyles) {
      return this.constructor.androidFeedbackStyles[this.styleValue];
    }

    return this.constructor.androidFeedbackStyles.soft;
  }
}
